import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractDamageDefinitionCreateForm from "./create";
import ContractDamageDefinitionEditForm from "./edit";
import {
  deleteDamageDefinition,
  getDamageDefinitionDetails,
  getDamageDefinitions,
} from "src/store/contract-damage-definition/saga";
import {
  DamageDefinitionDetailDto,
  DamageDefinitionDto,
} from "src/store/contract-damage-definition/type";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import { useNavigate } from "react-router";
const ContractDamageDefinitionsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<DamageDefinitionDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<DamageDefinitionDetailDto>();
  const navigate = useNavigate();
  const columns = [
    {
      text: t("Contract.DamageDefinition.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.DamageDefinition.PageTitle")}
        metaTag={t("Contract.DamageDefinition.MetaTag")}
        gridProps={{
          addTitle: t("Contract.DamageDefinition.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getDamageDefinitions,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getDamageDefinitionDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          gridButtons(keyValue, data) {
            if (data.DataTypeId === 3) {
              return (
                <ColumnButton
                  buttonType={"custom"}
                  custombutton={{
                    text: t(
                      "Contract.DamageDefinition.OptionsButton"
                    ).toString(),
                  }}
                  onClick={() =>
                    navigate("/contract/damage-definitions/picklist/" + data.Id)
                  }
                />
              );
            }
          },
          deleteButton: {
            text: (id, data: DamageDefinitionDto) =>
              t("Contract.DamageDefinition.DeleteQA", {
                name: data.Name,
              }),
            action: deleteDamageDefinition,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <ContractDamageDefinitionCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getDamageDefinitions,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractDamageDefinitionEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getDamageDefinitions,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractDamageDefinitionsPage;
